import { useState, useEffect } from "react";
import { isEqual } from "lodash";

const useAreaCookie = () => {
    const [cookie, setCookie] = useState(window.cookie.get());
    let oldCookie = cookie;

    // Check if Area changed every 3 seconds
    useEffect(() => {
        const duration = 3 * 1000; // N * seconds
        const interval = setInterval(() => {
            const newCookie = window.cookie.get();
            if (!isEqual(newCookie, oldCookie)) {
                setCookie(newCookie);
                oldCookie = newCookie;
            }
        }, duration);
        return () => clearInterval(interval);
    }, []);

    return cookie;
};

export default useAreaCookie;
